import { render, staticRenderFns } from "./virtual-organization.vue?vue&type=template&id=60eebe6b&scoped=true&"
import script from "./virtual-organization.vue?vue&type=script&lang=js&"
export * from "./virtual-organization.vue?vue&type=script&lang=js&"
import style0 from "./virtual-organization.vue?vue&type=style&index=0&id=60eebe6b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eebe6b",
  null
  
)

export default component.exports